import React from 'react';
import MediaQueries from 'react-responsive';

import metaData from 'marketing-website/data/metadata.js';
import Page from 'marketing-website/components/modules/Page';
import HeroMedia from 'marketing-website/components/modules/Hero/HeroMedia';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import BorderTop from 'marketing-website/components/commons/BorderTop';

import Assets from './Assets';
import Code from './Code';
import CtaBlock from './CtaBlock';
import Design from './Design';
import Sync from './Sync';

const PAGE_COLOR = 'green';

export default function FeatureHandoff() {
  const {
    features: { handoff },
  } = metaData;
  return (
    <Page
      title={handoff.title}
      meta={[
        {
          name: 'description',
          content: handoff.description,
        },
        {
          name: 'keywords',
          content: handoff.keywords,
        },
      ]}
      header={{ isLight: true }}
      footer
    >
      <HeroMedia
        backgroundColor={PAGE_COLOR}
        color="white"
        tag="h1"
        headline="Automatically create specs and design handoff for developers, saving your team hours of manual work"
        headlineMaxWidth={1000}
        name="mkt_features_handoff"
        type="video"
      />
      <Whitespace />
      <Assets />
      <Sync color={PAGE_COLOR} />
      <Code color={PAGE_COLOR} />
      <MediaQueries minWidth={770}>
        <Whitespace />
      </MediaQueries>
      <BorderTop>
        <Design color={PAGE_COLOR} />
      </BorderTop>
      <CtaBlock />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/handoff/index.js